import { render, staticRenderFns } from "./ExportUsersInStructure.vue?vue&type=template&id=9b2c4c24"
import script from "./ExportUsersInStructure.vue?vue&type=script&lang=js"
export * from "./ExportUsersInStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports